import { Component, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { NativeMarket } from "@capacitor-community/native-market";
import { Capacitor } from "@capacitor/core";
import { StorageService } from 'src/app/providers/storageService/storage.service';


@Component({
  selector: 'app-about-modal',
  templateUrl: './about-modal.component.html',
  styleUrls: ['./about-modal.component.scss'],
})

export class AboutModalComponent implements OnInit {
  version : string;
  display_version : string;
  whatsnew : string;
  iosID: string = 'id1059957191';
  androidID: string = 'com.medicalbilling.mbe';
  isIOS: boolean = false;
  isAndroid: boolean = false;
  constructor(
    private apiService: ApiService, 
    private appVersion: AppVersion, 
    public popoverController: PopoverController,
    public modalController: ModalController,
    public storageService: StorageService,
  ) { 

  }

  ngOnInit() {

    this.storageService.get('appVersion').then(res => {
      this.display_version=res;      
      this.version = this.display_version;
    this.appVersion.getVersionNumber().then((res)=>{
        this.version = res;
        this.getWhatsNew();
      }, (err)=>{
        //console.log('Err: ',err)
        this.version = this.display_version;
        this.getWhatsNew();
      });
    });
    //console.log('Platform: ',Capacitor.getPlatform());
    if (Capacitor.getPlatform() === "android") {
      this.isAndroid = true;
    }
    if (Capacitor.getPlatform() === "ios") {
      this.isIOS = true;
    }
  }

openAppStore() {
  let appId = this.iosID;
  if (Capacitor.getPlatform() === "android") {
    appId = this.androidID;
  }
  
  NativeMarket.openStoreListing({
    appId: appId,
  });
}

  getWhatsNew() {
    const params = {
      version: this.version
    };
    
    this.apiService
      .post('whatsnew', params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.whatsnew = res.data.whatsnew;
          }          
        },
        (err) => {           
        }
      );
  }
  onModalDismiss() {
    this.popoverController.dismiss(false);
  }
  
}
